module.exports = __webpack_public_path__ + "img/py.a70b32d0.svg";